import { arrayParamsInterceptor } from 'app/shared/api/microservices';
import { clearAuth } from 'app/store/reducers/app/authentication';
import { useAppDispatch } from 'app/store/store';
import axios from 'axios';
import { useEffect, useRef } from 'react';

const TIMEOUT = 1 * 60 * 1000;

export const useAxiosInterceptors = () => {
  const dispatch = useAppDispatch();
  const interceptorIds = useRef<{ request: number | null; params: number | null; response: number | null }>({
    request: null,
    params: null,
    response: null,
  });

  useEffect(() => {
    axios.defaults.timeout = TIMEOUT;
    axios.defaults.baseURL = SERVER_API_URL;

    interceptorIds.current.request = axios.interceptors.request.use(
      config => config,
      error => Promise.reject(error),
    );

    interceptorIds.current.params = axios.interceptors.request.use(
      config => arrayParamsInterceptor(config),
      error => Promise.reject(error),
    );

    interceptorIds.current.response = axios.interceptors.response.use(
      response => response,
      err => {
        const status = err.status || (err.response ? err.response.status : 0);
        if (status === 401) {
          dispatch(clearAuth());
        }
        return Promise.reject(err);
      },
    );

    return () => {
      const { request, params, response } = interceptorIds.current;
      if (request !== null) axios.interceptors.request.eject(request);
      if (params !== null) axios.interceptors.request.eject(params);
      if (response !== null) axios.interceptors.response.eject(response);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
